import { Flex, PrimarySecondaryPage, OnboardingLayout } from "@wayflyer/flyui";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";
import { OnboardingStepper } from "onboarding";

import { DocumentUploadSupportingContent } from "../../../components";
import { useDocumentQuery } from "../../../queries/document-uploads/queries";
import { useFundingApplication } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import {
  DebtAgreementsDocumentUpload,
  DocumentNavigationGroup,
  useDocumentNavigationActions,
  MESSAGES,
} from "../components";

export const DebtAgreementsDocumentUploadPage = () => {
  const intl = useIntl();
  const isNewOnboardingFlowEnabled = useFeatureFlagEnabled("enable_new_onboarding_setup_flow");
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationData } = useFundingApplication(customerDomain);
  const { data: uploadedDocuments } = useDocumentQuery(customerDomain, fundingApplicationData.id);
  const hasUploadedDocuments = !!uploadedDocuments?.filter(
    (doc) => doc.documentType === UploadDocumentType.COMPANY_DEBT_AGREEMENT
  ).length;

  const { primaryAction, secondaryAction } = useDocumentNavigationActions({
    forType: UploadDocumentType.COMPANY_DEBT_AGREEMENT,
  });

  if (isNewOnboardingFlowEnabled) {
    return (
      <OnboardingLayout
        variant="wide"
        titleSlot={<OnboardingStepper currentStep={4} />}
        title={intl.formatMessage(MESSAGES.debtAgreementsTitle)}
        actions={{ primary: primaryAction, secondary: secondaryAction }}
      >
        <Flex maxWidth="550px">
          <DebtAgreementsDocumentUpload />
        </Flex>
      </OnboardingLayout>
    );
  }

  const DebtAgreementDocumentUploadPrimary = (
    <Flex direction="column" gap="8">
      <DebtAgreementsDocumentUpload />
      <DocumentNavigationGroup
        isStepComplete={hasUploadedDocuments || fundingApplicationData.isCompanyDebtAgreementSkipped === true}
        forType={UploadDocumentType.COMPANY_DEBT_AGREEMENT}
      />
    </Flex>
  );

  return (
    <PrimarySecondaryPage
      titleSlot={<OnboardingStepper currentStep={4} />}
      showStepperBackground={true}
      title={intl.formatMessage(MESSAGES.debtAgreementsTitle)}
      primaryContent={DebtAgreementDocumentUploadPrimary}
      secondaryContent={<DocumentUploadSupportingContent />}
    />
  );
};
